<template>
  <div class="page-main">
    <!-- 表格操作条 -->
    <vxe-toolbar ref="refToolbar" size="mini" :loading="loading">
      <template #buttons>
        <el-button type="success" size="mini" @click="itemAdd">新增账户</el-button>
      </template>
    </vxe-toolbar>

    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      :loading="loading"
      :data="tableDataMain"
      :columns="tableColumn"
      :height="this.$util.getViewHeight() - 36 - 148"
    >
      <!-- slot_header -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          @change="headerFilterChange"
        />
      </template>

      <!-- slot_default -->
      <template #default_operate="{ row }">
        <el-link type="primary" @click="itemEdit(row)">编辑</el-link>
        <el-link type="danger" @click="itemDelete(row)">删除</el-link>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-增改账户 -->
    <PopupBank
      v-if="isShowPopupBank"
      :show.sync="isShowPopupBank"
      :data.sync="itemObj"
      @success="searchListData"
    />
  </div>
</template>

<script>
export default {
  components: { PopupBank: () => import('./popup-bank') },
  data() {
    return {
      loading: true,

      keyword: '',
      filterData: {},
      sortData: {
        id: 'asc'
      },

      // table
      headerFilterUrl: '/admin/gcvip/bank/searchHeard',
      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          field: 'bank_short_name',
          title: '账户名称',
          slots: { header: 'header_input' }
        },
        {
          field: 'bank_code',
          title: '银行账号',
          slots: { header: 'header_input' }
        },
        {
          field: 'bank_company',
          title: '开户名',
          slots: { header: 'header_input' }
        },
        {
          field: 'bank_name',
          title: '开户行',
          slots: { header: 'header_input' }
        },
        {
          field: 'bank_type',
          title: '账户备注',
          slots: { header: 'header_input' }
        },
        { title: '操作', width: 160, slots: { default: 'default_operate' } }
      ],
      tableDataMain: [],
      pageOptions: {
        ...this.$constant.page
      },
      isShowPopupBank: false,
      itemDefault: {
        id: '',
        bank_short_name: '',
        bank_code: '',
        bank_company: '',
        bank_name: '',
        bank_type: ''
      },
      itemObj: {}
    }
  },
  created() {
    this.initItemObj()
    this.getListData()
  },
  methods: {
    // 初始化itemObj
    initItemObj() {
      this.itemObj = this.$util.deepCopy(this.itemDefault)
    },
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取数据列表
    getListData() {
      this.loading = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/bank/list',
        data: {
          keyword: this.keyword,
          currentPage: this.pageOptions.currentPage,
          pageSize: this.pageOptions.pageSize,
          sortData: this.sortData,
          filterData: this.filterData
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableDataMain = res.data.page.list
            this.pageOptions.pageSize = res.data.page.pageSize
            this.pageOptions.total = res.data.page.totalRow
            this.pageOptions.currentPage = res.data.page.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 项-新增
    itemAdd() {
      this.isShowPopupBank = true
      this.initItemObj()
    },
    // 项-编辑
    itemEdit(row) {
      this.isShowPopupBank = true
      this.itemObj = this.$util.deepCopy(row)
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm(`id：${row.id}，您确认要删除该数据?`, '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/bank/delete',
            params: {
              id: row.id
            }
          }).then((res) => {
            if (res.status === 200 && res.data.state === 'ok') {
              this.$message.success('删除成功')
              this.getListData()
            }
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
